import { forwardRef } from 'react'

import styles from './CheckoutLayout.module.css'

export interface CheckoutLayoutProps {
  /** Header content (logo, language switcher, etc.) */
  header?: React.ReactNode
  /** Order summary sidebar (left side in desktop) */
  sidebar?: React.ReactNode
  /** Main content area - payment form (right side in desktop) */
  children?: React.ReactNode
  /** Footer content (disclaimer, copyright, etc.) */
  footer?: React.ReactNode
  /** Additional class name */
  className?: string
}

/**
 * CheckoutLayout - Two-column layout for checkout page
 *
 * Desktop: Left sidebar (order summary) | Right main (payment form)
 * Mobile: Stacked layout with collapsible order summary
 */
export const CheckoutLayout = forwardRef<HTMLDivElement, CheckoutLayoutProps>(
  ({ header, sidebar, children, footer, className }, ref) => {
    return (
      <div
        ref={ref}
        className={`${styles.layout} ${className ?? ''}`}
        data-ga-module="checkout_page"
      >
        {header && <header className={styles.header}>{header}</header>}
        <div className={styles.content}>
          <div className={styles.container}>
            {/* Left: Order Summary */}
            {sidebar && <aside className={styles.sidebar}>{sidebar}</aside>}
            {/* Right: Payment Form */}
            <main className={styles.main}>{children}</main>
          </div>
        </div>
        {footer && <footer className={styles.footer}>{footer}</footer>}
      </div>
    )
  }
)

CheckoutLayout.displayName = 'CheckoutLayout'
